<template>
    <div v-if="!isMobile">
      <IndexHeaderNav  />
      <router-view class="router" />
        <Bottom />
    </div>
    <!--移动端-->
    <div v-else>
        <LayoutMobileHeader />
        <router-view class="router" />
    </div>
</template>

<script>
    import Bottom from "@components/layout/Bottom"
    import common from "../mixin/common";
    import LayoutMobileHeader from "@components/layout/LayoutMobileHeader";
    import IndexHeaderNav from "@views/index/components/IndexHeaderNav.vue";

    export default {
        name: "notHomePage",
        mixins: [common],
        components: {
          IndexHeaderNav,
            Bottom,
            LayoutMobileHeader
        }
    }
</script>

<style scoped lang="less">
.router{
    min-height: calc(100vh - 260px);
}

</style>
